module.exports = __webpack_public_path__ + "img/icon-hearclearly.3923faaa.png";